import { useAuthStore } from '@/store/authStore';

export function AuthDebug() {
  const { user, isAuthenticated, token } = useAuthStore();

  if (!import.meta.env.DEV) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 bg-black/80 text-white p-4 rounded-lg text-xs max-w-sm z-50">
      <h3 className="font-bold mb-2">🐛 Auth Debug</h3>
      <div className="space-y-1">
        <div>isAuthenticated: {String(isAuthenticated)}</div>
        <div>hasToken: {String(!!token)}</div>
        <div>hasUser: {String(!!user)}</div>
        <div>userId: {user?.id || 'null'}</div>
        <div>userEmail: {user?.email || 'null'}</div>
        <div>userRole: {user?.role || 'null'}</div>
        <div>firstName: {user?.firstName || 'null'}</div>
        <div>lastName: {user?.lastName || 'null'}</div>
        <div>tokenInStorage: {String(!!localStorage.getItem('auth_token'))}</div>
        <div>userIdInStorage: {String(!!localStorage.getItem('user_id'))}</div>
      </div>
    </div>
  );
}